import React from 'react';
import { FadeInSection } from './ui/FadeInSection';
import { CheckSquare, ArrowRight } from 'lucide-react';
export function PainAndAgitation() {
  return <>
      {/* SECTION 4 — PAIN CHECKLIST */}
      <section className="bg-warmWhite px-4 py-16 md:py-20" data-id="element-162">
        <div className="max-w-2xl mx-auto" data-id="element-163">
          <FadeInSection data-id="element-164">
            <h3 className="text-xl md:text-2xl font-bold text-chocolate mb-8 text-center" data-id="element-165">
              Respondé honestamente:
            </h3>

            <div className="space-y-4 mb-10" data-id="element-166">
              {['¿Llegás a las 4pm con un antojo que ninguna fruta puede callar?', '¿Sentís culpa cada vez que comés algo dulce?', '¿El lunes empezás de nuevo y el viernes ya "te arruinaste"?', '¿Sabés qué "deberías" comer pero tu cuerpo pide otra cosa?'].map((item, idx) => <div key={idx} className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm border border-cream-dark" data-id="element-167">
                  <CheckSquare className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-168" />
                  <p className="text-lg text-textBody font-medium" data-id="element-169">{item}</p>
                </div>)}
            </div>

            <div className="text-center bg-cream p-6 rounded-2xl border border-gold/20" data-id="element-170">
              <p className="text-xl font-bold text-chocolate mb-2" data-id="element-171">
                Si marcaste 2 o más...
              </p>
              <p className="text-lg text-textBody" data-id="element-172">
                no es falta de voluntad.
                <br data-id="element-173" />
                Es que nadie te explicó cómo funciona tu cerebro con el dulce.
              </p>
            </div>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 5 — AGITATION */}
      <section className="bg-chocolate-light px-4 py-16 md:py-24" data-id="element-174">
        <div className="max-w-2xl mx-auto" data-id="element-175">
          <FadeInSection data-id="element-176">
            <div className="prose prose-lg mx-auto text-cream" data-id="element-177">
              <p className="italic text-xl text-gold-light mb-6" data-id="element-178">
                Son las 11 de la noche.
                <br data-id="element-179" />
                No tenés hambre.
                <br data-id="element-180" />
                Pero algo en tu cabeza pide dulce.
              </p>

              <div className="pl-6 border-l-4 border-gold mb-8" data-id="element-181">
                <p className="font-medium mb-2 text-warmWhite" data-id="element-182">
                  El debate interno empieza:
                </p>
                <p className="italic text-gold" data-id="element-183">
                  "Si como, me arruino el día."
                </p>
                <p className="italic text-gold" data-id="element-184">
                  "Pero si no como, no duermo."
                </p>
              </div>

              <p className="text-lg mb-8 text-warmWhite/80" data-id="element-185">
                Terminás comiendo.
                <br data-id="element-186" />
                Terminás con culpa.
                <br data-id="element-187" />Y mañana empezás de nuevo.
              </p>

              <p className="text-xl font-bold text-gold mb-8" data-id="element-188">
                Eso no es una falla tuya.
                <br data-id="element-189" />
                Es tu biología sin las herramientas correctas.
              </p>

              <div className="bg-chocolate p-8 rounded-2xl shadow-warm mb-8 border border-gold/20" data-id="element-190">
                <p className="font-bold text-gold mb-4" data-id="element-191">
                  Ya lo intentaste todo:
                </p>
                <ul className="space-y-3" data-id="element-192">
                  <li className="flex items-center gap-3" data-id="element-193">
                    <ArrowRight className="w-5 h-5 text-urgency shrink-0" data-id="element-194" />
                    <span className="text-warmWhite/90" data-id="element-195">
                      Dieta sin azúcar (duró 9 días)
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-196">
                    <ArrowRight className="w-5 h-5 text-urgency shrink-0" data-id="element-197" />
                    <span className="text-warmWhite/90" data-id="element-198">
                      Recetarios fit (ingredientes imposibles)
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-199">
                    <ArrowRight className="w-5 h-5 text-urgency shrink-0" data-id="element-200" />
                    <span className="text-warmWhite/90" data-id="element-201">
                      Fuerza de voluntad (agotada a las 6pm)
                    </span>
                  </li>
                </ul>
              </div>

              <div className="text-center" data-id="element-202">
                <p className="text-2xl font-bold text-warmWhite mb-2" data-id="element-203">
                  El problema no sos vos.
                </p>
                <p className="text-xl text-gold-light font-medium" data-id="element-204">
                  El problema es que ninguna solución fue diseñada para la mujer
                  argentina.
                </p>
              </div>
            </div>
          </FadeInSection>
        </div>
      </section>
    </>;
}